<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="申请列表" name="application">
        <el-form :inline="true" style="margin-bottom: 20px;">
          <el-form-item>
            <el-input
              v-model="searchForm.userName"
              placeholder="申请人名称"
              clearable
              style="width: 200px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchForm.userEmail"
              placeholder="申请人邮箱"
              clearable
              style="width: 200px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.applicationStatus" placeholder="申请状态" style="width: 150px" clearable>
              <el-option label="待审核" value="1"></el-option>
              <el-option label="已通过" value="2"></el-option>
              <el-option label="已拒绝" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="applicationDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="getApplicationList">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="applicationTableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          stripe>
          <el-table-column
            prop="userName"
            label="申请人名称"
            width="150">
          </el-table-column>
          <el-table-column
            prop="userEmail"
            label="申请人邮箱"
            width="200">
          </el-table-column>
          <el-table-column
            prop="applicationStatusDesc"
            label="申请状态"
            width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.applicationStatus == 1" type="warning">待审核</el-tag>
              <el-tag v-else-if="scope.row.applicationStatus == 2" type="success">已通过</el-tag>
              <el-tag v-else-if="scope.row.applicationStatus == 3" type="danger">已拒绝</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            width="180"
            label="申请时间">
          </el-table-column>
          <el-table-column
            prop="auditTime"
            width="180"
            label="审核时间">
          </el-table-column>
          <el-table-column
            prop="auditRemark"
            label="审核备注">
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.applicationStatus == 1"
                size="mini"
                type="success"
                @click="handleAudit(scope.row, 2)">通过</el-button>
              <el-button
                v-if="scope.row.applicationStatus == 1"
                size="mini"
                type="danger"
                @click="handleAudit(scope.row, 3)">拒绝</el-button>
              <span v-else>已审核</span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleApplicationSizeChange"
          @current-change="handleApplicationCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="applicationPage.current"
          :page-size="applicationPage.size"
          :total="applicationPage.total"
          style="margin-top: 20px; float: right;">
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="共创成员列表" name="member">
        <el-form :inline="true" style="margin-bottom: 20px;">
          <el-form-item>
            <el-input
              v-model="memberSearchForm.name"
              placeholder="用户名"
              clearable
              style="width: 200px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="memberSearchForm.email"
              placeholder="邮箱"
              clearable
              style="width: 200px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="memberSearchForm.isCoCreationMember" placeholder="共创成员" style="width: 150px" clearable>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getMemberList">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="memberTableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          stripe>
          <el-table-column
            prop="name"
            label="用户名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            width="200">
          </el-table-column>
          <el-table-column
            prop="isCoCreationMember"
            label="共创成员"
            width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isCoCreationMember == 1" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="organize"
            label="组织名称">
          </el-table-column>
          <el-table-column
            prop="createTime"
            width="180"
            label="注册时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="200"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.isCoCreationMember == 0"
                size="mini"
                type="success"
                @click="handleUpdateMemberStatus(scope.row, 1)">设为共创成员</el-button>
              <el-button
                v-else
                size="mini"
                type="danger"
                @click="handleUpdateMemberStatus(scope.row, 0)">取消共创成员</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleMemberSizeChange"
          @current-change="handleMemberCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="memberPage.current"
          :page-size="memberPage.size"
          :total="memberPage.total"
          style="margin-top: 20px; float: right;">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 审核对话框 -->
    <el-dialog
      title="审核共创计划申请"
      :visible.sync="auditDialogVisible"
      width="500px">
      <el-form :model="auditForm" label-width="100px">
        <el-form-item label="申请人">
          <span>{{ auditForm.userName }}</span>
        </el-form-item>
        <el-form-item label="申请邮箱">
          <span>{{ auditForm.userEmail }}</span>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditForm.applicationStatus">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核备注">
          <el-input
            v-model="auditForm.auditRemark"
            type="textarea"
            :rows="4"
            placeholder="请输入审核备注">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CoCreation",
  data() {
    return {
      activeTab: 'application',
      searchForm: {},
      applicationDate: [],
      applicationTableData: [],
      applicationPage: {
        total: 0,
        size: 10,
        current: 1,
      },
      memberSearchForm: {},
      memberTableData: [],
      memberPage: {
        total: 0,
        size: 10,
        current: 1,
      },
      auditDialogVisible: false,
      auditForm: {
        applicationId: null,
        userName: '',
        userEmail: '',
        applicationStatus: 2,
        auditRemark: ''
      }
    }
  },
  created() {
    this.getApplicationList()
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'member') {
        this.getMemberList()
      }
    },
    handleApplicationSizeChange(val) {
      this.applicationPage.size = val
      this.getApplicationList()
    },
    handleApplicationCurrentChange(val) {
      this.applicationPage.current = val
      this.getApplicationList()
    },
    handleMemberSizeChange(val) {
      this.memberPage.size = val
      this.getMemberList()
    },
    handleMemberCurrentChange(val) {
      this.memberPage.current = val
      this.getMemberList()
    },
    getApplicationList() {
      this.$axios.post("/uxm/co-creation/application/list", {
        userName: this.searchForm.userName,
        userEmail: this.searchForm.userEmail,
        applicationStatus: this.searchForm.applicationStatus ? parseInt(this.searchForm.applicationStatus) : null,
        startDate: this.applicationDate === null || this.applicationDate.length === 0 ? null : this.applicationDate[0],
        endDate: this.applicationDate === null || this.applicationDate.length === 0 ? null : this.applicationDate[1],
        current: this.applicationPage.current,
        size: this.applicationPage.size,
      }).then(res => {
        if (res && res.data && res.data.data) {
          this.applicationTableData = res.data.data.records || []
          this.applicationPage.size = res.data.data.size || 10
          this.applicationPage.current = res.data.data.current || 1
          this.applicationPage.total = res.data.data.total || 0
        } else {
          this.applicationTableData = []
          this.applicationPage.total = 0
        }
      }).catch(error => {
        console.error('获取申请列表失败:', error)
        this.applicationTableData = []
        this.applicationPage.total = 0
      })
    },
    getMemberList() {
      this.$axios.post("/uxm/user/page", {
        name: this.memberSearchForm.name,
        email: this.memberSearchForm.email,
        isCoCreationMember: this.memberSearchForm.isCoCreationMember ? parseInt(this.memberSearchForm.isCoCreationMember) : null,
        current: this.memberPage.current,
        size: this.memberPage.size,
      }).then(res => {
        if (res && res.data && res.data.data) {
          this.memberTableData = res.data.data.records || []
          this.memberPage.size = res.data.data.size || 10
          this.memberPage.current = res.data.data.current || 1
          this.memberPage.total = res.data.data.total || 0
        } else {
          this.memberTableData = []
          this.memberPage.total = 0
        }
      }).catch(error => {
        console.error('获取成员列表失败:', error)
        this.memberTableData = []
        this.memberPage.total = 0
      })
    },
    handleAudit(row, status) {
      this.auditForm.applicationId = row.id
      this.auditForm.userName = row.userName
      this.auditForm.userEmail = row.userEmail
      this.auditForm.applicationStatus = status
      this.auditForm.auditRemark = ''
      this.auditDialogVisible = true
    },
    submitAudit() {
      this.$axios.post("/uxm/co-creation/application/audit", {
        applicationId: this.auditForm.applicationId,
        applicationStatus: this.auditForm.applicationStatus,
        auditRemark: this.auditForm.auditRemark
      }).then(res => {
        this.$message({
          type: 'success',
          message: '审核成功'
        })
        this.auditDialogVisible = false
        this.getApplicationList()
        if (this.activeTab === 'member') {
          this.getMemberList()
        }
      }).catch(error => {
        console.error('审核失败:', error)
        const errorMsg = error.response?.data?.msg || error.message || '审核失败，请稍后重试'
        this.$message.error(errorMsg)
      })
    },
    handleUpdateMemberStatus(row, status) {
      const action = status === 1 ? '设为共创成员' : '取消共创成员'
      this.$confirm(`确定要${action}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post("/uxm/user/updateCoCreationMemberStatus", null, {
          params: {
            userId: row.id,
            isCoCreationMember: status
          }
        }).then(res => {
          if (res && res.data && res.data.code === 200) {
            this.$message({
              type: 'success',
              message: `${action}成功`
            })
            // 刷新列表
            this.getMemberList()
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg || `${action}失败`
            })
          }
        }).catch(error => {
          console.error('更新共创成员状态失败:', error)
          this.$message({
            type: 'error',
            message: `${action}失败，请稍后重试`
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-pagination {
  float: right;
  margin-top: 22px;
}
</style>

